import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { FiArrowRight, FiLoader } from "react-icons/fi";

const subjects = [
  ["rh-copilot", "RH Copilot"],
  ["portal-rh", "Portal RH Empresarial"],
  ["consultoria-protheus-rh", "Consultoria Protheus RH"],
  ["demonstracao", "Demonstração"],
  ["suporte", "Suporte"],
  ["outros", "Outros"],
];

const initialForm = { nome: "", email: "", telefone: "", empresa: "", assunto: "outros", mensagem: "", website: "" };

export default function ContactForm() {
  const location = useLocation();
  const preset = new URLSearchParams(location.search).get("assunto");
  const presetSubject = preset === "demonstracao-portal-rh" ? "portal-rh" : preset === "portal-rh" ? "portal-rh" : "outros";
  const [form, setForm] = useState({ ...initialForm, assunto: presetSubject });
  const [status, setStatus] = useState({ loading: false, success: false, error: "" });

  const handleChange = (event) => setForm((current) => ({ ...current, [event.target.name]: event.target.value }));
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (form.website) return;
    setStatus({ loading: true, success: false, error: "" });
    try {
      if (!form.nome.trim() || !form.email.trim() || !form.assunto || !form.mensagem.trim()) {
        throw new Error("Preencha nome, e-mail, assunto e mensagem.");
      }
      const response = await fetch("/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          nome: form.nome.trim(), email: form.email.trim(), telefone: form.telefone.trim(),
          empresa: form.empresa.trim(), assunto: form.assunto, mensagem: form.mensagem.trim(), website: form.website,
        }),
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok || !data.success) throw new Error(data.error || "Não foi possível enviar sua mensagem. Tente novamente.");
      setForm({ ...initialForm, assunto: presetSubject });
      setStatus({ loading: false, success: true, error: "" });
    } catch (error) {
      setStatus({ loading: false, success: false, error: error.message || "Ocorreu um erro ao enviar sua mensagem." });
    }
  };

  return (
    <form className="contact-form" onSubmit={handleSubmit} noValidate>
      <div className="contact-form__honeypot" aria-hidden="true"><label htmlFor="website">Website</label><input id="website" name="website" tabIndex="-1" autoComplete="off" value={form.website} onChange={handleChange} /></div>
      {status.success && <div className="contact-form__feedback contact-form__feedback--success" role="status">Mensagem enviada com sucesso. Entraremos em contato em breve.</div>}
      {status.error && <div className="contact-form__feedback contact-form__feedback--error" role="alert">{status.error}</div>}
      <div className="contact-form__fields">
        <label>Nome *<input name="nome" value={form.nome} onChange={handleChange} required autoComplete="name" disabled={status.loading} /></label>
        <label>E-mail *<input type="email" name="email" value={form.email} onChange={handleChange} required autoComplete="email" disabled={status.loading} /></label>
        <label>Telefone <input type="tel" name="telefone" value={form.telefone} onChange={handleChange} autoComplete="tel" disabled={status.loading} /></label>
        <label>Empresa <input name="empresa" value={form.empresa} onChange={handleChange} autoComplete="organization" disabled={status.loading} /></label>
        <label className="contact-form__full">Assunto *
          <select name="assunto" value={form.assunto} onChange={handleChange} required disabled={status.loading}>
            {subjects.map(([value, label]) => <option key={value} value={value}>{label}</option>)}
          </select>
        </label>
        <label className="contact-form__full">Mensagem *
          <textarea name="mensagem" value={form.mensagem} onChange={handleChange} required rows="6" disabled={status.loading} />
        </label>
      </div>
      <p className="contact-form__privacy">Ao enviar, seus dados serão usados somente para responder ao contato.</p>
      <button className="contact-form__submit" type="submit" disabled={status.loading}>
        {status.loading ? <><FiLoader className="contact-form__spin" aria-hidden="true" /> Enviando...</> : <>Enviar mensagem <FiArrowRight aria-hidden="true" /></>}
      </button>
    </form>
  );
}
